import { DataTableDesignTokens } from "@primeuix/themes/types/datatable";
import { primitiveColorTokens } from "src/assets/layout/styles/tokens/primitive";

export const datatable: DataTableDesignTokens = {
    row: {
        color: primitiveColorTokens.blue[850],
    },
    css: () => {
        /**
         * Base Overrides for p-table
         */
        const base = `
            .p-datatable {
                border-collapse: collapse;

                .p-datatable-thead > tr > th {
                    font-family: var(--p-azara-fonts-font-family-sans);
                    font-weight: 600;
                    text-transform: uppercase;
                    font-size: 0.875rem;
                    letter-spacing: 0.025em;
                }

                &.p-datatable-scrollable {
                    .p-datatable-scrollable-header {
                        background: var(--p-azara-shade-0);
                    }
                }
            }

            .p-datatable.p-datatable-striped {
                .p-datatable-tbody > tr:nth-child(odd) {
                    background-color: var(--p-azara-white-100) !important;
                }

                .p-datatable-tbody > tr:nth-child(even) {
                    background-color: var(--p-azara-white-350) !important;
                }
            }

            .p-datatable-sort-icon {
                transform: scale(1.2) translateY(2px);
            }
        `;

        return base;
    },
};
